import script from "./AddRSMFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddRSMFile.vue?vue&type=script&setup=true&lang=ts"

import "./AddRSMFile.vue?vue&type=style&index=0&id=8394b1dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8394b1dc"]])

export default __exports__